import { useState, useEffect } from "react";
import { GraduationCap } from "lucide-react";

import { callApi } from "../utils";
import GroupDetails from "./group-details";

/* ---------------------------------------------------------------------- */
/*  Кабинет студента                                                       */
/* ---------------------------------------------------------------------- */

export default function StudentWorkspace() {
  const [myGroups, setMyGroups] = useState([]);

  const getMyGroups = () => {
    callApi({
      method: "GET",
      path: "api/student/practice-groups",
      needAuth: true,
    }).then((response) => {
      if (response.error) {
        console.error(response.error);
      } else {
        const respArr = response.response;
        if (respArr) {
          setMyGroups(respArr);
        } else {
          console.error(respArr);
        }
      }
    });
  };

  useEffect(getMyGroups, []);

  if (!myGroups.length) {
    return (
      <div className="workspace single">
        <div className="empty-state">
          <GraduationCap size={28} />
          <h3>Вы пока не привязаны ни к одной группе</h3>
          <p>
            Как только преподаватель добавит вашу группу, здесь появятся
            практические работы.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="workspace single">
      {myGroups.map((g) => (
        <GroupDetails key={g.id} group={g} getMyGroups={getMyGroups} />
      ))}
    </div>
  );
}
